<template>
    

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody />

        <div class="hp-main-layout" style="overflow-x: hidden;" >

            <!-- HEADER -->
            <HeaderBody />

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" style="padding: 10px;" >

                

                <div class="row mb-32 gy-8 dash-top">

                    <!-- POSTS -->
                    <div class="col-12 " >

                        <div class="row g-32" >

                            <div class="col-12 col-xl-8" style=" padding-bottom: 1000px; ">

                                <!-- <h2 class="mm-none" style="margin-top: -35px;"></h2> -->
                                <h2 class="dd-none" style="margin-top: -35px;"></h2>

                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12 ftab d-none" id="myTab" role="tablist" style="margin-top: -10px">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="all-tab" data-bs-toggle="tab"
                                            data-bs-target="#all" role="tab" aria-controls="all" aria-selected="true"
                                            style="cursor: pointer;">Post</h6>
                                    </li>

                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content" id="allTabContent" >
                                    <!-- ALL -->
                                    <div class="tab-pane fade show active"  id="all" role="tabpanel"
                                        aria-labelledby="all-tab" style="padding-bottom: 500px;  ">

                                        <div class="col-12" style="margin-bottom: 20px;"
                                            v-for="(post, index) in postListRaw" :key="'number' + index">

                                            <div class="card hp-card-4" v-if="post.isLoading">
                                                <div class="card-body">
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                    <br> <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                    </div>

                                                    <br>

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="650" :height="400"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                    </div>

                                                    <br> 
                                                    
                                                </div>
                                            </div>

                                            <div class="card hp-card-4" v-else>
                                                <div class="card-body">

                                                    <div class="row">

                                                        <div class="col">

                                                            <p class="hp-badge-text"
                                                                style="position: absolute; top: 30px; right: 20px; font-weight: 300;">
                                                                {{ post.dateD }}</p>

                                                            <div class="row align-items-center">
                                                                <div class="w-auto px-0"
                                                                    @click="profileClick(post.userId, post.userName)"
                                                                    style="cursor: pointer;">
                                                                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                        style="width: 48px; height: 48px; ">
                                                                        <img :src="post.profilePic" class="hp-img-cover"
                                                                            style="width: 48px; height: 48px; background-color: black; object-fit: cover; border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                    </div>
                                                                </div>

                                                                <div class="w-auto ms-8 px-0 mt-12"
                                                                    @click="profileClick(post.userId, post.userName)">
                                                                    <span
                                                                        class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">{{
                                                                        post.fullName }}

                                                                        <span v-if="post.userType == 'model'">
                                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 2px; margin-top: -3px;" > 
                                                                        </span> 

                                                                        <span v-if="post.sexuality == 'gay'">
                                                                            <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'lesbian'">
                                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>

                                                                        <span v-else-if="post.sexuality == 'bisexual'">
                                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                        </span>
                                                                        
                                                                    </span>
                                                                    <p
                                                                        class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                        @{{ post.userName }}</p>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <p style="margin-top: 10px; margin-bottom: 5px; ">{{
                                                            post.caption }}</p>

                                                    </div>

                                                </div>

                                                <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="post.postType == 'paid' && post.isPaid && post.isSubscribed"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 550px; background-color: #9146ff; position: relative;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="baesnap"
                                                                    style=" width: 100%; height: 550px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video webkit-playsinline="webkit-playsinline" controls 
                                                                    style="height: 550px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; " >
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px; position: relative;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 40%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 40%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px; position: relative;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px; position: relative;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline"
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px; position: relative;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList"  ></FsLightbox>

                                                        
                                                    </div>

                                                    <div v-else-if="post.postType == 'paid' && !post.isPaid && post.isSubscribed" style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="ppvClick(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Unlock post for &#8358; {{ post.priceD }}</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                    <div v-else-if="post.isSubscribed || post.isOwner || post.postType == 'freex'"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff; position: relative;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else>

                                                                    <video webkit-playsinline="webkit-playsinline" playsinline
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 40%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px; position: relative;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 40%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px; position: relative;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video webkit-playsinline="webkit-playsinline" playsinline
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px; position: relative;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px; position: relative;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls webkit-playsinline="webkit-playsinline" playsinline
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button  @click="subClick2(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px; z-index: 999;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                </div>

                                                <div v-if="noUserName == 'noUserName'"></div>
                                                <div v-else
                                                    style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                    <div
                                                        style="display: flex; justify-content: center; align-items: center;">

                                                        <div>

                                                            <div v-if="post.isLiked" :id="post.idD + 'like'"
                                                                @click="likeClick(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                            <div v-else :id="post.idD + 'like'"
                                                                @click="likeClick(post.idD + 'like', index, post)"
                                                                class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class=" iconly-Light-Heart2"></i>
                                                            </div>

                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.likeCount }}
                                                        </span>

                                                        <div v-if="post.isBookmarked" :id="post.idD + 'book'"
                                                            @click="bookClick(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <div v-else :id="post.idD + 'book'"
                                                            @click="bookClick(post.idD + 'book', index, post)"
                                                            class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                        </div>

                                                        <span style="margin-left: 5px; width: 40px; font-weight: 600;"
                                                            class="hp-badge-text">
                                                            {{ post.bookmarkCount }}
                                                        </span>



                                                        

                                                    </div>

                                                    <div>

                                                        <button @click="tipClick(post)"
                                                            class=" hp-cursor-pointer btn btn-sm btn-outline-primary rounded-circle"
                                                            data-bs-toggle="modal" data-bs-target="#sendTip"
                                                            style="padding: 5px 10px; " v-if="!post.isOwner">
                                                            <span>&#8358;</span>

                                                        </button>



                                                    </div>

                                                </div>

                                                <!-- COMMENTS -->
                                                <div class="divider mt-18 mb-16"></div>

                                                <div v-if="noUserName == 'noUserName'"></div>
                                                
                                                <div v-else>

                                                    <form @submit.prevent="postComment" style="width: 100%; padding: 20px;">

                                                    <div
                                                        style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: 0px;">

                                                        <div style="width: 100%; margin-right: 10px; position: relative;">

                                                            <textarea style="line-height: 20px; padding: 20px; padding-right: 60px;" name="description"
                                                                v-model="commentInput" maxlength="300" class="form-control" rows="3"
                                                                placeholder="Type comment here..." required></textarea>

                                                            <button style="position: absolute; top: 30px; right: 10px; width: 45px; height: 45px;" class="btn btn-sm btn-icon-only rounded-circle btn-primary" id="commentBtn">
                                                                <i class="hp-text-color-dark-0 iconly-Light-Send" ></i>
                                                            </button>

                                                        </div>

                                                        

                                                    </div>

                                                    </form>

                                                    <div class="col-12" v-for="(com, index) in comments" :key="index">

                                                        <div class="row" style="padding-left: 20px; padding-right: 20px; cursor: pointer;">
                                                            <div class="col-12" style="margin-bottom: 20px;">
                                                                <div
                                                                    style="justify-content: flex-start; display: flex; align-items: flex-start; width: 100%;">
                                                                    <div class="w-auto px-0" @click="profileClick(com.userId, com.userName)" data-bs-dismiss="modal">
                                                                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                            style="width: 38px; height: 38px; ">
                                                                            <img :src="com.profilePic" class="hp-img-cover"
                                                                                style="width: 38px; height: 38px; background-color: black; object-fit: cover; ">
                                                                        </div>
                                                                    </div>

                                                                    <div class="w-auto ms-8 px-0 mt-4" style="width: 100%;">
                                                                        <p class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 mt-4 titleM"
                                                                            style="font-size: 14px; "> {{ com.name }} </p>
                                                                        <p style="font-size: 12px; margin-top: -5px; width: 100%; word-break: break-all;"
                                                                            class=" fw-normal hp-text-color-dark-30"> {{ com.comment }} </p>

                                                                        <p style="font-size: 9px; font-style: italic;"
                                                                            class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">{{ com.date }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    <div id="emptyComments2"
                                                        style="width:100%; display: flex; justify-content: center; align-items: center;">

                                                        <InfiniteLoading @infinite="handleInfinite5" class="spinner">
                                                        </InfiniteLoading>

                                                    </div>

                                                    <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyComments">
                                                        <p class="hp-badge-text">No comments yet...</p>
                                                    </div>

                                                    <!--  -->

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptyAllHome2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: none; justify-content: center; align-items: center; flex-direction: column;" id="emptyAllHome">
                                            <p class="hp-badge-text">No posts yet...</p>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4" >

                                <SuggestionsBody />

                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top" style="z-index: 9;">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SUCCESS2 -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal2">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText2 }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS2">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SEND TIP -->
    <div class="modal fade" id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
            <div class="modal-content">
                <div class="modal-header">

                    <div class="w-auto px-0" >
                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                            <img :src="modelProfilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                        </div>
                    </div>

                    <h4 style="text-align: center; width: 100%" class="modal-title">Send Tip</h4>

                    <button style="z-index: 10;" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                        
                </div>

                <div class="modal-body" style="margin-top: -40px;">

                    <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                    <form @submit.prevent="sendTip">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Amount</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="100 to 50,000"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Message</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Type a message here..." style="line-height: 20px; padding-top: 10px;"
                                v-model="message" maxlength="500"></textarea>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer">

                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>



                </div>


            </div>
        </div>
    </div>

    <!-- PPV -->
    <div class="modal fade" id="ppv" tabindex="-1" aria-labelledby="ppvLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Pay &#8358; {{ppvPost.priceD}} </h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <!-- <p class="hp-p1-body">Pay <strong></strong> to gain full access to this post </p> -->
                        
                        <div class="mb-24" style="margin-top: 10px;">

                            <label for="displayName" class="form-label">Password</label>
                            <input type="password" class="form-control" placeholder="*********" aria-label="Username"
                                    aria-describedby="basic-addon1" required v-model="password">

                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="ppv">Pay</button>
                    </div>
                </div>
            </div>
    </div>

</template>

<style scoped>
.shx {
    width: 1000px;
}

.shm {
    max-width: 100%;
    max-height: 500px;
    object-fit: cover;
}

.ftab{
    overflow-x:auto;
    flex-wrap:nowrap; 
    scrollbar-width: none; 
    
}



@media only screen and (max-width: 666px) {

    .shx {
        width: 350px;

    }

    .shm {
        max-width: 100%;
        max-height: 700px;
        object-fit: cover;
    }

    .ftab{
        overflow-x:auto;
        flex-wrap:nowrap; 
        scrollbar-width: none; 
        
    }


}
</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SuggestionsBody from '@/components/SuggestionsBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";
    import FsLightbox from "fslightbox-vue";
    import LvSkeleton from "lightvue/skeleton";
    import LvCodeLoader from 'lightvue/skeleton/preset/CodeLoader';

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, setDoc, Timestamp } from "firebase/firestore";
    import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential, signInWithEmailAndPassword } from "firebase/auth"
    import { db } from '@/firebase';
    import axios from 'axios';
    import { MD5 } from 'md5-js-tools';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SuggestionsBody,
            FooterBody,
            InfiniteLoading,
            FsLightbox,
            LvSkeleton,
            LvCodeLoader,
        },

        data() {
            return {
                toggler: false,
                loadingText: "",
                errorText: "",
                successText: "",
                successText2: "",

                balance: "",

                postId: "",
                postListRaw: [],
                
                postList: [],

                lastDocSnapshot: null,
                lastDocSnapshot2: null,
                lastDocSnapshot3: null,
                lastDocSnapshot4: null,
                lastDocSnapshot5: null,
                lastDocSnapshot6: null,

                isFirstPost: true,
                hasScrolledToBottom: false,

                modelUsername: "",
                mediaList: [],
                mediaName: "",
                mediaSize: "",
                mediaType: "",
                mediaUrl: "",

                commentPic: "",
                commentCount: "",
                comments: [],
                commentInput: "",
                postIndex: "",

                likeSpamList: [],
                bookSpamList: [],

                mBundle1: "",
                mBundle2: "",
                mBundle3: "",
                mProfilePic: "",
                mUsername: "",
                mName: "",
                mEmail: "",
                mModelId: "",

                tip: "",
                modelId: "",
                modelName: "",
                modelProfilePic: "",
                modelEmail: "",
                message: "",
                tipPostId: "",

                cModelId: "",

                followingList: [],
                subList: [],

                ppvPost: "",
                password: "",
                noUserName: ""

            }
        },

        mounted() {

            document.body.style.overflowY = 'scroll';
            document.body.style.padding = '0px';
            document.getElementById("mobileLogo").style.display = 'none';
            document.getElementById("mobileTitle").textContent = "Post";

            this.getStart();

        },

        unmounted(){
            if(sessionStorage.getItem("noUserName") == "noUserName" || this.noUserName == "noUserName"){
                const auth = getAuth();
                signOut(auth).then(() => {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.$router.push({ name: 'sign-in' });
                    return;
                })
            }
        },

        methods: {


            tipClick(post) {

                this.modelId = post.userId;
                this.modelName = post.fullName;
                this.modelUsername = post.userName;
                this.modelProfilePic = post.profilePic;
                this.tipPostId = post.id;
                this.modelEmail = post.email;

            },

            getStart(){
                const auth = getAuth();
                if(sessionStorage.getItem("userName") == null || auth == null){

                    signInWithEmailAndPassword(auth, "forgot@baesnap.com", "forgotPassword")
                    .then( async (data) => {
                        this.noUserName = "noUserName";
                        sessionStorage.setItem("noUserName", "noUserName");
                    })

                };

            },

            detectMob() {
                return ( ( window.innerWidth <= 800 ) );
            },

            async sendTip() {

                let balance, newBalance, uFullname, uEmail, uProfilePic, uUsername;

                this.loadingText = "Sendind tip to @" + this.modelUsername + "...";
                this.$refs.loadingModal.classList.add("bg-active");

                if (this.tip > 500000) {
                    this.errorText = "Tips can not be larger than ₦ 500,000";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                if (this.tip < 1000) {
                    this.errorText = "Minimum amount for tips is ₦ 1000";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                const auth = getAuth();

                //check balance
                if (auth.currentUser.uid == this.modelId) {
                    this.errorText = "You can not send a tip to yourself...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }


                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    balance = userSnap.data().balance;
                    uUsername = userSnap.data().displayId;
                    uFullname = userSnap.data().name;
                    uProfilePic = userSnap.data().profilePic;
                    uEmail = userSnap.data().email;

                    if (balance < this.tip) {
                        this.errorText = "Insufficient balance. Please top up your account and try again.";
                        this.$refs.errorModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }
                }
                else {
                    this.$router.push({ name: 'sign-in' });
                    return;
                }

                newBalance = balance - this.tip;

                await updateDoc(userRef, {
                    balance: newBalance,
                });

                const modelRef = doc(db, "Users", this.modelId);
                await updateDoc(modelRef, {
                    earnings: increment(this.tip),
                    tipBalance: increment(this.tip),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                //update user transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdrawal",
                    title: "Sent tip",
                    description: " Sent a tip of ₦ " + this.tip + " to @" + this.modelName,
                    amount: this.tip,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: secs,
                    status: "successful",
                    userId: auth.currentUser.uid,
                    fullName: this.modelName,
                    username: this.modelUsername,
                    profilePic: this.modelProfilePic,
                    
                });

                //update model transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Deposit",
                    title: "Received tip",
                    description: this.message,
                    amount: this.tip,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: secs,
                    status: "successful",
                    userId: this.modelId,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    

                });

                //model notification

                if (this.modelId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", this.modelId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Tips",
                        description: "Sent you a tip of ₦ " + this.tip,
                        ownerId: this.modelId,
                        userId: auth.currentUser.uid,
                        username: uUsername,
                        fullName: uFullname,
                        profilePic: uProfilePic,
                        email: uEmail,
                        date: serverTimestamp(),
                        dateN: secs,
                        postId: this.tipPostId,
                    });

                }

                if (this.message == "") {
                    this.message = "none";
                }

                axios.post('https://api.baesnap.com/v1/tip-mail', {
                    toName: this.modelName,
                    toEmail: this.modelEmail,
                    username: uUsername,
                    amount: Number(this.tip).toLocaleString("us-Us"),
                    message: this.message
                })
                    .then(function (response) {
                        console.log(response);

                    })

                $('#sendTip').modal('hide');
                this.successText2 = "Tip sent successfully";
                this.$refs.successModal2.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            subClick(post) {

                this.mBundle1 = post.bundle1;
                this.mBundle2 = post.bundle2;
                this.mBundle3 = post.bundle3;
                this.mUsername = post.userName;
                this.mModelId = post.userId;
                this.mEmail = post.email;

            },

            subClick2(post){
                sessionStorage.setItem("otherId", post.userId);
                this.$router.push({name: 'sub-pay'});
            },

            ppvClick(post){
                this.ppvPost = post;
                $('#ppv').modal('show');
            },

            ppv(){

                this.loadingText = "Authenticating...";
                this.$refs.loadingModal.classList.add("bg-active");

                
                if(this.password == ""){
                    this.errorText = "Please enter your password to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                let passwordHash = MD5.generate(String(this.password));

                const auth = getAuth();
                const user = auth.currentUser;

                if(this.ppvPost.userId == auth.currentUser.uid){
                    return;
                }

                const credential = EmailAuthProvider.credential( sessionStorage.getItem("email"), passwordHash );

                reauthenticateWithCredential(user, credential)
                .then((result) => {
                    //password correct
                    this.ppv2();

                })
                .catch((error) => {
                    //console.log(error);
                    this.errorText = "Incorrect password...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                });
            },

            async ppv2(){
                let balance, newBalance, uFullname, uEmail, uUsername, uProfilePic;

                const auth = getAuth();
                this.loadingText = "Processing transaction...";

                //check balance
                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    balance = userSnap.data().balance;
                    uFullname = userSnap.data().name;
                    uUsername = userSnap.data().displayId;
                    uProfilePic = userSnap.data().profilePic;
                    uEmail = userSnap.data().email;

                    if (balance < this.ppvPost.price) {
                        this.errorText = "Insufficient balance. Please top up your account and try again.";
                        this.$refs.errorModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }
                }
                else {
                    this.$router.push({ name: 'sign-in' });
                    return;
                }

                await updateDoc(userRef, {
                    balance: increment(-this.ppvPost.price),
                });

                //update model balance
                const modelRef = doc(db, "Users", this.ppvPost.userId);
                await updateDoc(modelRef, {
                    earnings: increment(this.ppvPost.price),
                    ppvBalance: increment(this.ppvPost.price),
                });

                //add to paidUsers
                await setDoc(doc(db, "UserPosts", this.ppvPost.id, "PaidUsers", auth.currentUser.uid), {});

                let mSecs = new Date().getTime() / 1000;
                let transSecs = 10000000000 / mSecs;

                //update user transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdrawal",
                    title: "Paid post",
                    description: " Paid to view post",
                    amount: this.ppvPost.price,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: auth.currentUser.uid,
                    fullName: this.ppvPost.fullName,
                    username: this.ppvPost.userName,
                    profilePic: this.ppvPost.profilePic,
                });

                //update model transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Deposit",
                    title: "Paid post",
                    description: "@" + uUsername + " paid to view your post",
                    amount: this.ppvPost.price,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: this.ppvPost.userId,
                    
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,

                });

                // NOTIFICATION
                if (this.ppvPost.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", this.ppvPost.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Paid posts",
                        description: "Paid for your post",
                        ownerId: this.ppvPost.userId,
                        userId: auth.currentUser.uid,
                        username: uUsername,
                        fullName: uFullname,
                        profilePic: uProfilePic,
                        email: uEmail,
                        date: serverTimestamp(),
                        dateN: secs,
                        postId: this.ppvPost.id,
                    });

                }

                axios.post('https://api.baesnap.com/v1/new-ppv-mail', {
                    toName: this.ppvPost.fullName,
                    toEmail: this.ppvPost.email,
                    username: "@" + uUsername,
                    amount: this.ppvPost.priceD,
                    
                })
                .then(function (response) {
                    //console.log(response);
                })

                $('#ppv').modal('hide');

                this.successText = "The transaction was completed successfully. You now have full access to the post.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async subscribe(days, price) {

                let balance, newBalance, uUsername, uFullname, uEmail, uProfilePic;

                const auth = getAuth();

                this.loadingText = "Subscribing to @" + this.mUsername + " for " + days + " days...";
                this.$refs.loadingModal.classList.add("bg-active");

                const typeRef = doc(db, "Users", this.mModelId);
                const typeSnap = await getDoc(typeRef);

                if (typeSnap.exists()) {
                    if (typeSnap.data().type == "user") {
                        this.loadingText = "";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }
                }
                else {
                    this.loadingText = "";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                //check balance
                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    balance = userSnap.data().balance;
                    uUsername = userSnap.data().displayId;
                    uFullname = userSnap.data().name,
                        uProfilePic = userSnap.data().profilePic;
                    uEmail = userSnap.data().email;

                    if (balance < Number(price)) {
                        this.errorText = "Insufficient balance. Please fund your account and try again.";
                        this.$refs.errorModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }
                }
                else {
                    this.$router.push({ name: 'sign-in' });
                    return;
                }

                let todaySecs = new Date().getTime() / 1000;
                let durationSecs = Number(days) * 24 * 60 * 60;
                let endDateSecs = todaySecs + durationSecs;

                newBalance = balance - Number(price);

                await updateDoc(userRef, {
                    balance: newBalance,
                });

                //update model balance
                const modelRef = doc(db, "Users", this.mModelId);
                await updateDoc(modelRef, {
                    earnings: increment(Number(price)),
                    fanCount: increment(1),
                    fanCountN: increment(-1)
                });

                //update model fan list
                await setDoc(doc(db, "UserFans", this.mModelId, "Fans", auth.currentUser.uid,), {
                    price: Number(price),
                    startDate: serverTimestamp(),
                    duration: Number(days),
                    endDate: endDateSecs,
                    status: "active",
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                });

                //update user sub list
                await setDoc(doc(db, "UserSubs", auth.currentUser.uid, "Subs", this.mModelId), {
                    price: Number(price),
                    startDate: serverTimestamp(),
                    duration: Number(days),
                    endDate: endDateSecs,
                    status: "active",
                    modelId: this.mModelId,
                    modelName: this.mName,
                    modelUserName: this.mUsername,
                    modelProfilePic: this.mProfilePic,
                    email: this.mEmail,
                });

                let mSecs = new Date().getTime() / 1000;
                let transSecs = 10000000000 / mSecs

                //update user transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdrawal",
                    title: "Subscription",
                    description: " Subscribed to @" + this.mUsername + " for " + days + " days",
                    amount: price,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: auth.currentUser.uid,
                    
                    fullName: this.mName,
                    username: this.mUsername,
                    profilePic: this.mProfilePic,
                });

                //update model transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Deposit",
                    title: "Subscription",
                    description: "@" + uUsername + " subscribed to your content for " + days + " days",
                    amount: price,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: this.mModelId,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,

                });

                // NOTIFICATION
                if (this.mModelId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", this.mModelId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Subs",
                        description: "Subscribed to your content for " + days + " at ₦ " + price,
                        ownerId: this.mModelId,
                        userId: auth.currentUser.uid,
                        username: uUsername,
                        fullName: uFullname,
                        profilePic: uProfilePic,
                        email: uEmail,
                        date: serverTimestamp(),
                        dateN: secs,
                        postId: "",
                    });

                }

                axios.post('https://api.Baesnap.com/v1/new-sub-mail', {
                    toName: this.mName,
                    toEmail: this.mEmail,
                    username: "@" + uUsername,
                    amount: Number(price).toLocaleString("us-Us"),
                    duration: days,
                })
                    .then(function (response) {
                        console.log(response);

                    })


                this.successText = "Successfully Subscribed to @" + this.mUsername + " for " + days + " days";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            profileClick(userId, userName) {

                const auth = getAuth();

                if (auth.currentUser.uid == userId) {
                    this.$router.push({ name: 'profile' });
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({ name: 'other-profile', params: { id: userName } });
                return;

            },

            async getFollowing() {
                const auth = getAuth();
                const querySnapshot = await getDocs(collection(db, "UserFollowing", auth.currentUser.uid, "Following"), limit(50));
                if (querySnapshot.docs.length > 0) {

                    querySnapshot.forEach((doc) => {
                        this.followingList.push(doc.id);
                    })

                }

            },

            async getSubs() {
                const auth = getAuth();
                const querySnapshot = await getDocs(collection(db, "UserSubs", auth.currentUser.uid, "Subs"), limit(100));
                if (querySnapshot.docs.length > 0) {

                    querySnapshot.forEach((doc) => {
                        this.subList.push(doc.id);
                    })

                }
            },

            async commentClick(post, index) {

                this.commentCount = post.commentCount;
                this.postId = post.id;
                this.cModelId = post.userId;
                this.postIndex = index;

                this.comments = [];
                this.commentInput = "";

                const querySnapshot = await getDocs(collection(db, "UserPosts", this.postId, "Comments"));
                querySnapshot.forEach((doc) => {
                    this.comments.unshift({
                        userId: doc.data().userId,
                        profilePic: doc.data().profilePic,
                        name: doc.data().name,
                        userName: doc.data().userName,
                        comment: doc.data().comment,
                        date: doc.data().date,
                    });
                });


            },

            async getComments(){

                this.postId = this.$route.params.id;

                let res = [];
                const q = query(collection(db, "UserPosts", this.postId, "Comments"), orderBy("dateN"), limit(20), startAfter(this.lastDocSnapshot6 || 0));
                
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot6 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                        querySnapshot.forEach(async (doc) => {

                            let result = {
                                userId: doc.data().userId,
                                profilePic: doc.data().profilePic,
                                name: doc.data().name,
                                userName: doc.data().userName,
                                comment: doc.data().comment,
                                date: doc.data().date,
                            }

                            this.comments.push(result);

                        })

                    }

                    return res.length;

            },

            async postComment() {

                this.postId = this.$route.params.id;

                document.getElementById("commentBtn").disabled = true;
                this.commentCount++;
                const auth = getAuth();

                let a = String(new Date());

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                //update list
                let commentObj = {
                    userId: auth.currentUser.uid,
                    profilePic: sessionStorage.getItem("profilePic"),
                    name: sessionStorage.getItem("fullName"),
                    userName: sessionStorage.getItem("userName"),
                    comment: this.commentInput,
                    date: a.slice(0, -36),
                    dateN: secs
                }

                this.comments.unshift(commentObj);
                //document.getElementById("comDiv").scrollIntoView();

                //update post comment db
                const postRef = doc(db, "UserPosts", this.postId);
                await updateDoc(postRef, {

                    commentCount: increment(1),

                });

                await addDoc(collection(db, "UserPosts", this.postId, "Comments"), {
                    userId: auth.currentUser.uid,
                    profilePic: sessionStorage.getItem("profilePic"),
                    name: sessionStorage.getItem("fullName"),
                    userName: sessionStorage.getItem("userName"),
                    comment: this.commentInput,
                    date: a.slice(0, -36),
                    dateN: secs
                });


                document.getElementById("commentBtn").disabled = false;
                //this.postListRaw[this.postIndex].commentCount++;

                // NOTIFICATION
                if (this.cModelId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", this.cModelId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs
                    await addDoc(collection(db, "UserNoti"), {
                        category: "Comments",
                        description: "Commented on your post: " + this.commentInput,
                        ownerId: this.cModelId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: this.postId,
                        dateN: secs
                    });

                }

                this.commentInput = "";

            },

            getOccurrence(array, value) {
                var count = 0;
                array.forEach((v) => (v === value && count++));
                return count;
            },

            async likeClick(id, index, post) {

                const auth = getAuth();

                this.likeSpamList.push(post.id);

                $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
                $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                //update list
                if (post.isLiked) {
                    this.postListRaw[index].likeCount--;
                    this.postListRaw[index].isLiked = false;

                    if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(-1),
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(-1),
                        likesN: increment(1)
                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
                }

                else {
                    this.postListRaw[index].likeCount++;
                    this.postListRaw[index].isLiked = true;

                    if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(1),

                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(1),
                        likesN: increment(-1)
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs;

                    await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if (post.userId != auth.currentUser.uid) {

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime() / 1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"), {
                            category: "Likes",
                            description: "Liked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs,
                        });

                    }

                }

            },

            async bookClick(id, index, post) {

                $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
                $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                const auth = getAuth();

                this.bookSpamList.push(post.id);

                //update list
                if (post.isBookmarked) {
                    this.postListRaw[index].bookmarkCount--;
                    this.postListRaw[index].isBookmarked = false;

                    if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(-1),

                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));

                    //remove bookmark post
                    await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
                }

                else {
                    this.postListRaw[index].bookmarkCount++;
                    this.postListRaw[index].isBookmarked = true;

                    if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(1),

                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    //add post to bookmark
                    await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if (post.userId != auth.currentUser.uid) {

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime() / 1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"), {
                            category: "Bookmarks",
                            description: "Bookmarked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs
                        });

                    }

                }
            },

            async likeClick2(id, index, post) {

                const auth = getAuth();

                this.likeSpamList.push(post.id);

                $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
                $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                //update list
                if (post.isLiked) {
                    this.postListRaw2[index].likeCount--;
                    this.postListRaw2[index].isLiked = false;

                    if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(-1),
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(-1),
                        likesN: increment(1)
                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
                }

                else {
                    this.postListRaw2[index].likeCount++;
                    this.postListRaw2[index].isLiked = true;

                    if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(1),

                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(1),
                        likesN: increment(-1)
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs;

                    await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if (post.userId != auth.currentUser.uid) {

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime() / 1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"), {
                            category: "Likes",
                            description: "Liked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs,
                        });

                    }

                }

            },

            async bookClick2(id, index, post) {

                $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
                $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                const auth = getAuth();

                this.bookSpamList.push(post.id);

                //update list
                if (post.isBookmarked) {
                    this.postListRaw2[index].bookmarkCount--;
                    this.postListRaw2[index].isBookmarked = false;

                    if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(-1),

                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));

                    //remove bookmark post
                    await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
                }

                else {
                    this.postListRaw2[index].bookmarkCount++;
                    this.postListRaw2[index].isBookmarked = true;

                    if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(1),

                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    //add post to bookmark
                    await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if (post.userId != auth.currentUser.uid) {

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime() / 1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"), {
                            category: "Bookmarks",
                            description: "Bookmarked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs
                        });

                    }

                }
            },

            async likeClick3(id, index, post) {

                const auth = getAuth();

                this.likeSpamList.push(post.id);

                $("#" + id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
                $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                //update list
                if (post.isLiked) {
                    this.postListRaw3[index].likeCount--;
                    this.postListRaw3[index].isLiked = false;

                    if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(-1),
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(-1),
                        likesN: increment(1)
                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
                }

                else {
                    this.postListRaw3[index].likeCount++;
                    this.postListRaw3[index].isLiked = true;

                    if (this.getOccurrence(this.likeSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(1),

                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(1),
                        likesN: increment(-1)
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs;

                    await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if (post.userId != auth.currentUser.uid) {

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime() / 1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"), {
                            category: "Likes",
                            description: "Liked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs,
                        });

                    }

                }

            },

            async bookClick3(id, index, post) {

                $("#" + id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
                $("#" + id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                const auth = getAuth();

                this.bookSpamList.push(post.id);

                //update list
                if (post.isBookmarked) {
                    this.postListRaw3[index].bookmarkCount--;
                    this.postListRaw3[index].isBookmarked = false;

                    if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(-1),

                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));

                    //remove bookmark post
                    await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id));
                }

                else {
                    this.postListRaw3[index].bookmarkCount++;
                    this.postListRaw3[index].isBookmarked = true;

                    if (this.getOccurrence(this.bookSpamList, post.id) > 2) {
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(1),

                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    //add post to bookmark
                    await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if (post.userId != auth.currentUser.uid) {

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime() / 1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"), {
                            category: "Bookmarks",
                            description: "Bookmarked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs
                        });

                    }

                }
            },

            async test() {

                let test = (await this.getUserInfoPost('TFCoaCOOZBUVinAWl8908DwL00D3')).profilePic;

                console.log(test);

            },

            closeE() {
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS() {
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeS2() {
                this.$refs.successModal2.classList.remove("bg-active");
                //this.$router.go();
            },

            fileSizeFormat(fileSize) {
                let mSize;
                if (Number(fileSize) >= 1073741824) {
                    mSize = (Number(fileSize) / 1073741824).toFixed(2) + " GB";
                }
                else if (Number(fileSize) >= 1048576) {
                    mSize = (Number(fileSize) / 1048576).toFixed(2) + " MB";
                }
                else if (Number(fileSize) >= 1024) {
                    mSize = (Number(fileSize) / 1024).toFixed(2) + " KB";
                }

                return mSize;
            },

            timeFormat(date) {

                let newFormat;

                TimeAgo.addDefaultLocale(en);
                const timeAgo = new TimeAgo('en-US');
                newFormat = timeAgo.format(Number(date));

                return newFormat;

            },

            kFormatter(num) {
                return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

            },

            async getNextPosts() {

                //get idD
                let postId = this.$route.params.id;
                let postIdD;

                const postRef = doc(db, "UserPosts", postId);
                const postSnap = await getDoc(postRef);

                if(postSnap.exists()){
                    postIdD = postSnap.data().idD;
                }

                let res = [];

                const q = query(collection(db, "UserPosts"), where("idD", "==", postIdD), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if (res.length > 0) {

                    querySnapshot.forEach(async (doc) => {

                        let urlList = [];
                        let imgCount = 0;
                        let vidCount = 0;
                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));
                        this.cModelId = doc.data().userId;

                        let result = {
                            isLoading: true,

                            id: doc.id,
                            idD: doc.data().idD,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username,
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            sexuality: "",
                            bundle1: 0,
                            bundle2: 0,
                            bundle3: 0,

                            isOwner: false,
                            isSubscribed: false,
                            tags: doc.data().tags,
                            caption: doc.data().caption,
                            category: doc.data().category,

                            timeStamp: doc.data().timeStamp,
                            dateFull: a2.slice(0, -36),
                            dateD: this.timeFormat(a1),

                            price: doc.data().price,
                            previewUrl: doc.data().previewUrl,
                            mediaList: doc.data().mediaList,

                            isLiked: false,
                            isBookmarked: false,

                            likeCount: doc.data().likeCount,
                            bookmarkCount: doc.data().bookmarkCount,
                            commentCount: doc.data().commentCount,

                            toggler: false,
                            urlList: urlList,
                            imgCount: imgCount,
                            vidCount: vidCount,
                            previewUrl2: [doc.data().previewUrl],

                            postType: doc.data().postType,
                            isPaid: false,
                            priceD: Number(doc.data().price).toLocaleString("us-US"),

                            userType: "",
                            profileType: ""

                        }

                        this.postListRaw.push(result);

                        let mIndex = this.postListRaw.length - 1;

                        await this.getFullName(doc.id, doc.data().userId, doc.data().mediaList, doc.data().previewUrl, mIndex);

                    })


                }


                return res.length;

            },

            async getUserInfoPost(userId) {

                let isOwner = false;
                let isSubscribed = false;
                let fanList = [];

                const auth = getAuth();

                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
                querySnapshot.forEach((doc) => {
                    fanList.push(doc.id);
                });


                //check if owner
                if (auth.currentUser.uid == userId) {
                    isOwner = true;
                    isSubscribed = true;
                }
                else {
                    for (let i = 0; i < fanList.length; i++) {
                        if (fanList[i] == auth.currentUser.uid) {
                            isSubscribed = true;
                        }
                    }
                }

                return {
                    profilePic: userSnap.data().profilePic,
                    fullName: userSnap.data().name,
                    userName: userSnap.data().displayId,
                    email: userSnap.data().email,
                    userType: userSnap.data().type,
                    isOwner: isOwner,
                    isSubscribed: isSubscribed,
                }

            },

            async getLikedStatus(postId) {

                let likedList = [];
                const auth = getAuth();

                const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "LikedList"));
                querySnapshot.forEach((doc) => {
                    likedList.push(doc.id);
                });

                for (let i = 0; i < likedList.length; i++) {
                    if (likedList[i] == auth.currentUser.uid) {
                        return true
                    }
                }

                return false;

            },

            async getBookmarkStatus(postId) {

                const auth = getAuth();
                let bookmarkList = [];

                const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "BookmarkList"));
                querySnapshot.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                for (let i = 0; i < bookmarkList.length; i++) {
                    if (bookmarkList[i] == auth.currentUser.uid) {
                        return true
                    }
                }

                return false;

            },

            async handleInfinite($state) {

                const newPostCount = await this.getNextPosts();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.postListRaw.length == 0) {
                    document.getElementById("emptyAllHome").style.display = "flex";

                }

                //no more posts
                document.getElementById("emptyAllHome2").style.display = "none";

                //no more posts
                return $state.complete();

            },

            async handleInfinite5($state){

                const newPostCount = await this.getComments();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.comments.length == 0) {
                    document.getElementById("emptyComments").style.display = "flex";
                }

                //no more posts
                document.getElementById("emptyComments2").style.display = "none";

                //no more posts
                return $state.complete();

            },

            async videoUrlToBase64(url) {
                try {
                    // Fetch the video as a Blob
                    const response = await fetch(url);
                    if (!response.ok) throw new Error('Network response was not ok');

                    const blob = await response.blob();

                    console.log("BLOBB :"+blob)
                    // Create a FileReader to convert Blob to Base64
                    const reader = new FileReader();
                    
                    return new Promise((resolve, reject) => {
                        reader.onloadend = () => {
                            // The result will be in the format: data:video/mp4;base64,...
                            resolve(reader.result);
                        };
                        reader.onerror = () => reject(new Error('Error reading blob'));
                        reader.readAsDataURL(blob);
                    });
                } catch (error) {
                    console.error('Error converting video URL to Base64:', error);
                    return null;
                }
            },

            getThumbnail(videoUrl){

                let thumbnail;
                const video = document.getElementById("videoGif2");
                video.src = videoUrl;
                video.currentTime = 2; // Start from the beginning

                video.addEventListener('loadeddata', () => {
                    const canvas = document.getElementById('canvasGif2');
                    const ctx = canvas.getContext('2d');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;

                    // Draw the video frame to the canvas
                    ctx.drawImage(video, 0, 0);

                    // Convert the canvas to a data URL and set it as the source for the poster image
                    // const posterImage = document.getElementById('posterImage');
                    thumbnail =  canvas.toDataURL('image/png');

                    //console.log("DATA URL"+canvas.toDataURL('image/png'));

                    // Clean up
                    URL.revokeObjectURL(video.src);

                    return thumbnail;

                });

                video.play();

            },

            async getFullName(id, userId, mediaList, previewUrl, mIndex) {

                let i = mIndex;
                let fanList = [];
                let likedList = [];
                let bookmarkList = [];
                let paidUsers = [];

                let urlList = [];
                let imgCount = 0;
                let vidCount = 0;

                for (let a = 0; a < mediaList.length; a++) {
                    urlList.push(mediaList[a].url)
                    if (mediaList[a].type.startsWith("image")) {
                        imgCount++;
                    }
                    else if (mediaList[a].type.startsWith("video")) {
                        vidCount++;
                    }
                }

                if(mediaList.length < 1){
                    urlList.push(previewUrl);
                }

                const auth = getAuth();
                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
                querySnapshot.forEach((doc) => {
                    fanList.push(doc.id);
                });

                const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
                querySnapshot2.forEach((doc) => {
                    likedList.push(doc.id);
                });

                const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
                querySnapshot3.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
                querySnapshot4.forEach((doc) => {
                    paidUsers.push(doc.id);
                });

                if (this.postListRaw[i].id == id) {
                        
                        this.postListRaw[i].fullName = userSnap.data().name;
                        this.postListRaw[i].userName = userSnap.data().displayId;
                        this.postListRaw[i].profilePic = userSnap.data().profilePic;
                        this.postListRaw[i].email = userSnap.data().email;
                        this.postListRaw[i].bundle1 = userSnap.data().bundle1;
                        this.postListRaw[i].bundle2 = userSnap.data().bundle2;
                        this.postListRaw[i].bundle3 = userSnap.data().bundle3;
                        this.postListRaw[i].sexuality = userSnap.data().sexuality;
                        this.postListRaw[i].userType = userSnap.data().type;
                        this.postListRaw[i].profileType = userSnap.data().profileType;

                        this.postListRaw[i].urlList = urlList;
                        this.postListRaw[i].vidCount = vidCount;
                        this.postListRaw[i].imgCount = imgCount;

                        if (auth.currentUser.uid == userId) {
                            this.postListRaw[i].isOwner = true;
                            this.postListRaw[i].isSubscribed = true;
                            this.postListRaw[i].isPaid = true;
                        }
                        else if (userSnap.data().type == "user") {
                            this.postListRaw[i].isSubscribed = true;
                        }
                        else if (userSnap.data().profileType == "free") {
                            this.postListRaw[i].isSubscribed = true;
                        }
                        else {
                            for (let b = 0; b < fanList.length; b++) {
                                if (fanList[b] == auth.currentUser.uid) {
                                    this.postListRaw[i].isSubscribed = true;
                                    break;
                                }
                            }
                        }

                        for (let c = 0; c < likedList.length; c++) {
                            if (likedList[c] == auth.currentUser.uid) {
                                this.postListRaw[i].isLiked = true;
                                break;
                            }
                        }

                        for (let d = 0; d < bookmarkList.length; d++) {
                            if (bookmarkList[d] == auth.currentUser.uid) {
                                this.postListRaw[i].isBookmarked = true;
                                break;
                            }
                        }

                        for (let e = 0; e < paidUsers.length; e++) {
                            if (paidUsers[e] == auth.currentUser.uid) {
                                this.postListRaw[i].isPaid = true;
                                break;
                            }
                        }

                        this.postListRaw[i].isLoading = false;

                    }

            },

        },
        
    }

</script>